module.exports = __webpack_public_path__ + "img/myApprovalLaunchico@2x.f1c71b49.png";